module.exports = __webpack_public_path__ + "img/grey_call.98509893.svg";